import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { MEDIA_API } from "./apiRoutes";

const mutateUpdateNewsMedia = async ({
  id,
  data,
}: {
  id: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${MEDIA_API}/${id}`, data);
};

const useUpdateNewsMediaMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateNewsMedia,
    ...queryParams,
  });

export default useUpdateNewsMediaMutation;
